import { render, staticRenderFns } from "./DKLXLookWrong.vue?vue&type=template&id=9e59a760&scoped=true"
import script from "./DKLXLookWrong.vue?vue&type=script&lang=js"
export * from "./DKLXLookWrong.vue?vue&type=script&lang=js"
import style0 from "./DKLXLookWrong.vue?vue&type=style&index=0&id=9e59a760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e59a760",
  null
  
)

export default component.exports